import { OpacityUpdater } from "./OpacityUpdater.js";
export async function loadOpacityUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("opacity", (container) => new OpacityUpdater(container), refresh);
}
